// import the library
import { library } from "@fortawesome/fontawesome-svg-core"

// import your icons
import { fal } from "@fortawesome/pro-light-svg-icons"
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons"

library.add(fal, faCircleExclamation)
